// Lib
import gql from 'graphql-tag';

// Types
import { NOTIFICATION } from '../types';

export const notificationsQuery = gql`
  query Notifications($cursor: String, $limit: Int) {
    notifications(cursor: $cursor, limit: $limit) {
      cursor
      hasMore
      items {
        ${NOTIFICATION}
      }
    }
  }
`;

export const unreadNotificationsCountQuery = gql`
  query UnreadNotificationsCount {
    unreadNotificationsCount
  }
`;
